import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const SwiperWrap = styled.div`
  padding-top: ${rem(38)};
`;

export const StyledSwiper = styled.div`
  .swiper-slide > div {
    z-index: 1;
    opacity: 0.4;
    filter: blur(5px);
    display: flex;
    justify-content: center;
    padding-top: ${rem(61)};
    padding-bottom: ${rem(5)};
    > img {
      width: ${rem(140)};
    }
  }
  & .swiper-slide-active {
    z-index: 2;
  }
  & .swiper-slide-active > div {
    > img {
      width: ${rem(142)};
    }
    padding-top: 0;
    padding-bottom: 0;
    scale: 1;
    z-index: 2;
    opacity: 1;
    filter: blur(0);
  }

  .swiper-pagination {
    position: absolute;
    bottom: ${rem(3)};
    margin-top: 0;
    &-bullet {
      background: ${({ theme }) => theme.color.white};
      opacity: 0.4;
      &-active {
        background: ${({ theme }) => theme.color.white};
        opacity: 1;
      }
    }
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const TextWrap = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.color['primary-100']};
  border-radius: 6px;
  padding: ${rem(4)} ${rem(8)};
  bottom: ${rem(-27)};
  left: 50%;
  transform: translateX(-50%);
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 7px solid transparent;
    border-radius: 6px;
    border-top: 0;
    margin-left: -7px;
    margin-top: -4px;
    border-bottom-color: ${({ theme }) => theme.color['primary-100']};
  }
`;

export const Image = styled.img``;
